import HsEducatorCompleteModal from './component'
export default HsEducatorCompleteModal
